import { NgModule } from '@angular/core';

import { CandidateAttachmentsUploadModule } from '@modules/candidates/+attachments/+upload/upload.module';
import { CandidateDetailsModule } from '@modules/candidates/+details/candidate-details.module';
import { CandidateFormModule } from '@modules/candidates/+form/candidate-form.module';
import { CandidateUploadModule } from '@modules/candidates/+upload-assign/candidate-upload.module';
import { CompaniesFilterModule } from '@modules/companies/filter';
import { JobsFormModule } from '@shared/job-form/job-form.module';
import { TeamMembersModalModule } from "@shared/modal/team-members/team-members-modal.module";

// TODO once https://github.com/angular/components/issues/16431 is
// implemented switch to CoalescingComponentFactoryResolver to dynamically load components
@NgModule({
  imports: [
    JobsFormModule,
    CandidateUploadModule,
    CandidateDetailsModule,
    CandidateFormModule,
    CandidateAttachmentsUploadModule,
    TeamMembersModalModule,
    CompaniesFilterModule,
  ],
})
export class ModalsModule {}
